import React from "react";
import { string, func, bool, number } from "prop-types";
import Switch from "react-switch";

const propTypes = {
  groupId: string.isRequired,
  facetId: string.isRequired,
  facetCount: number,
  facetLabel: string.isRequired,
  selected: bool.isRequired,
  onFacetChange: func.isRequired,
};

const SwitchToggle = (props) => {
  const { groupId, facetId, facetCount, facetLabel, selected, onFacetChange } =
    props;

  return (
    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    <label className="switch-toggle">
      <span className="switch-toggle__text">{facetLabel}</span>
      <span className="switch-toggle__switch-wrapper">
        <Switch
          onColor="#313A44"
          offColor="#fff"
          offHandleColor="#313A44"
          onHandleColor="#fff"
          uncheckedIcon={false}
          checkedIcon={false}
          onChange={() => onFacetChange(groupId, facetId)}
          checked={selected}
        />
      </span>
    </label>
  );
};

SwitchToggle.propTypes = propTypes;
export default SwitchToggle;
